// import { useGlobalStore } from "@/store/GlobalStore";
import {
  AppealStatus,
  ConfirmStatus,
} from "@/pages/consumption/view/billing/constant";
import { Operation, OperationButton } from "@/components/operation-button";
import { IExportData } from "@/pages/export-list/types";
// import { currentBillDate } from "@/pages/consumption/view/billing/helper/currentBillDate";
// import { useTranslation } from "react-i18next";

export function Operations({ record }: { record: IExportData }) {
  // const { isSubAccount } = useGlobalStore();

  // const { t } = useTranslation("center");

  // const { appealStatus, confirmStatus, consumeDate } = record;
  const { appealStatus } = record;
  const disabledConfirm =
    typeof appealStatus === "number" &&
    [AppealStatus.Submitted, AppealStatus.Handling].includes(appealStatus);

  // const showApplyBill =
  //   typeof appealStatus !== "number" &&
  //   consumeDate === currentBillDate() &&
  //   confirmStatus !== ConfirmStatus.Confirmed &&
  //   !isSubAccount;

  // const showAppealProgress = typeof appealStatus === "number" && !isSubAccount;

  return (
    <>
      <OperationButton operation={Operation.DownloadBill} />

      {record.confirmStatus === ConfirmStatus.Unconfirmed && (
        <OperationButton
          disabled={disabledConfirm}
          operation={Operation.ConfirmBill}
        />
      )}

      {/* {showApplyBill && (
        <OperationButton
          text={t("consumption_bill_appeal")}
          operation={"appealBill"}
        />
      )}

      {showAppealProgress && (
        <OperationButton
          text={t("consumption_complaint_progress")}
          operation={"appealBill"}
        />
      )} */}
    </>
  );
}
